var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitColOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H13C11.8954 0 11 0.89543 11 2V10C11 11.1046 11.8954 12 13 12H18C19.1046 12 20 11.1046 20 10V2C20 0.89543 19.1046 0 18 0Z",
    fill: "#272C55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5H13C12.1716 0.5 11.5 1.17157 11.5 2V10C11.5 10.8284 12.1716 11.5 13 11.5H18C18.8284 11.5 19.5 10.8284 19.5 10V2C19.5 1.17157 18.8284 0.5 18 0.5Z",
    stroke: "#272C55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H2C0.89543 0 0 0.89543 0 2V10C0 11.1046 0.89543 12 2 12H7C8.10457 12 9 11.1046 9 10V2C9 0.89543 8.10457 0 7 0Z",
    fill: "#272C55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V10C0.5 10.8284 1.17157 11.5 2 11.5H7C7.82843 11.5 8.5 10.8284 8.5 10V2C8.5 1.17157 7.82843 0.5 7 0.5Z",
    stroke: "#272C55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4H19.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8H19.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8H8.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4H8.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.5V11.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.5V11.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitColOperationIcon);
export default __webpack_public_path__ + "static/media/SplitColOperationIcon.db06107216c1c19074ca35f38f07b4e0.svg";
export { ForwardRef as ReactComponent };